import axios from 'axios';

export const getFullName = obj =>
    obj && typeof obj != "undefined" ? obj.first_name
        + " " + (obj.middle_name ? obj.middle_name + " " : "") + obj.last_name : "";
export const getMonth = (month_num, is_short = false) => {
    var num = parseInt(month_num);
    var month_word = "";
    switch (num) {
        case 1:
            month_word =  is_short ? "Jan" : "January"
            break;
        case 2:
            month_word =  is_short ? "Feb" : "February"
            break;
        case 3:
            month_word =  is_short ? "Mar" : "March"
            break;
        case 4:
            month_word =  is_short ? "Apr" : "April"
            break;
        case 5:
            month_word =  "May"
            break;
        case 6:
            month_word =  is_short ? "Jun" : "June"
            break;
        case 7:
            month_word =  is_short ? "Jul" : "July"
            break;
        case 8:
            month_word =  is_short ? "Aug" : "August"
            break;
        case 9:
            month_word =  is_short ? "Sep" : "September"
            break;
        case 10:
            month_word =  is_short ? "Oct" : "October"
            break;
        case 11:
            month_word =  is_short ? "Nov" : "November"
            break;
        case 12:
            month_word =  is_short ? "Dec" : "December"
            break;
        default:
            break;
    }
    return month_word;
}

export const getMaxDays = (month_num, is_leap_year = false) => {
    var days = 0;
    var parsed = parseInt(month_num);
    switch(parsed)
    {
        case 1: 
            days = 31;
            break;
        case 2: 
            days = is_leap_year ? 29 : 28;
            break;
        case 3: 
            days = 31;
            break;
        case 4: 
            days = 30;
            break;
        case 5: 
            days = 31;
            break;
        case 6: 
            days = 30;
            break;
        case 7: 
            days = 31;
            break;
        case 8: 
            days = 31;
            break;
        case 9: 
            days = 30;
            break;
        case 10: 
            days = 31;
            break;
        case 11: 
            days = 30;
            break;
        case 12: 
            days = 31;
            break;
        default: 
        

    }
    return days;
}

export const s2ab = (s) => {
    var buf = new ArrayBuffer(s.length);
    var view = new Uint8Array(buf);
    for (var i = 0; i != s.length; ++i) view[i] = s.charCodeAt(i) & 0xFF;
    return buf;
}

export const canBeViewedWeb = file_ext => {
    var exts = ["pdf", "png", "jpg", "jpeg"];
    return exts.includes(file_ext);
}

export const ordinal_suffix_of = (i, ordinalOnly = false) => {
    var j = i % 10,
        k = i % 100;
    if (j == 1 && k != 11) {
        return i + "st";
    }
    if (j == 2 && k != 12) {
        return i + "nd";
    }
    if (j == 3 && k != 13) {
        return i + "rd";
    }
    return (ordinalOnly ? "" : i) + "th";
}

export const getOptions = (url, predicate = d => d) => {
    return axios.get(url, { withCredentials: true }).then(r => r.data.map(predicate))
        .catch(e => console.log(`${e}, rglobal_options_error`));
}

export function isFunction(functionToCheck) {
    return functionToCheck && {}.toString.call(functionToCheck) === '[object Function]';
}